/**
 * Where to send the user after login. Captured at /login and consumed at
 * /post-login via sessionStorage, which survives the Auth0 redirect round-trip
 * (the same place Auth0 keeps its own transaction state).
 */
export const POST_LOGIN_RETURN_URL_KEY: string = 'vb_post_login_return_url';

/**
 * Whether a string is a safe in-app path to redirect to after login. Guards
 * against open redirects (absolute/protocol-relative URLs) and login loops
 * (the /login and /post-login routes themselves).
 */
export function isSafeReturnUrl(url: unknown): url is string {
    return (
        typeof url === 'string' &&
        url.startsWith('/') &&
        !url.startsWith('//') &&
        !url.startsWith('/login') &&
        !url.startsWith('/post-login')
    );
}
